import { render, staticRenderFns } from "./TheSourceUpload.vue?vue&type=template&id=13fd215d&scoped=true&"
import script from "./TheSourceUpload.vue?vue&type=script&lang=js&"
export * from "./TheSourceUpload.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceUpload.vue?vue&type=style&index=0&id=13fd215d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd215d",
  null
  
)

export default component.exports